import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ContactUs.css';

const ContactUs = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    type: 'question',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const feedbackTypes = [
    { value: 'question', label: 'Question', icon: '❓' },
    { value: 'feature_request', label: 'Feature Request', icon: '💡' },
    { value: 'bug_report', label: 'Bug Report', icon: '🐛' },
    { value: 'country_request', label: 'Country Request', icon: '🌍' },
    { value: 'general', label: 'General Feedback', icon: '💬' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const token = localStorage.getItem('accessToken');
      const apiUrl = process.env.REACT_APP_API_URL || '';
      const response = await fetch(`${apiUrl}/api/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
        setTimeout(() => {
          navigate('/my-feedback');
        }, 2000);
      } else {
        setError(data.message || 'Failed to submit feedback');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  if (success) {
    return (
      <div className="contact-us-container">
        <div className="success-message">
          <div className="success-icon">✅</div>
          <h2>Thank You!</h2>
          <p>Your feedback has been submitted successfully.</p>
          <p>We'll review it and get back to you soon.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-us-container">
      <div className="contact-us-header">
        <h1>Contact Us</h1>
        <p>Have a question, suggestion, or feedback? We'd love to hear from you!</p>
      </div>

      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-group">
          <label htmlFor="type">What would you like to share?</label>
          <div className="type-selector">
            {feedbackTypes.map(type => (
              <label key={type.value} className={`type-option ${formData.type === type.value ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="type"
                  value={type.value}
                  checked={formData.type === type.value}
                  onChange={handleChange}
                />
                <span className="type-icon">{type.icon}</span>
                <span className="type-label">{type.label}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="subject">
            Subject <span className="required">*</span>
          </label>
          <input
            type="text"
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            maxLength={100}
            required
            placeholder="Brief summary of your message"
          />
          <div className="char-count">{formData.subject.length}/100</div>
        </div>

        <div className="form-group">
          <label htmlFor="message">
            Message <span className="required">*</span>
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            maxLength={1000}
            required
            rows={8}
            placeholder="Please provide details..."
          />
          <div className="char-count">{formData.message.length}/1000</div>
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="form-actions">
          <button type="button" onClick={() => navigate(-1)} className="btn-secondary">
            Cancel
          </button>
          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Submitting...' : 'Submit Feedback'}
          </button>
        </div>

        <div className="rate-limit-notice">
          <small>You can submit up to 5 feedback messages per day.</small>
        </div>
      </form>
    </div>
  );
};

export default ContactUs;
